export const InfoIcon = ({
  width = 24,
  height = 24,
  fill = "#000000",
  stroke = "#000000",
  strokeWidth = 2,
  className,
}: {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <circle
          cx="12"
          cy="12"
          data-name="--Circle"
          fill="none"
          id="_--Circle"
          r="10"
          stroke={stroke}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width={strokeWidth}
        ></circle>{" "}
        <line
          fill="none"
          stroke={stroke}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width={strokeWidth}
          x1="12"
          x2="12"
          y1="12"
          y2="16"
        ></line>{" "}
        <line
          fill="none"
          stroke={stroke}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width={strokeWidth}
          x1="12"
          x2="12"
          y1="8"
          y2="8"
        ></line>{" "}
      </g>{" "}
    </svg>
  );
};
